import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Settings } from 'ui/icons';

import { displayContent } from '../content';
import { useContentEditorPreferencesContext } from '../../context/ContentEditorPreferencesContext';

export const PreferencesButton = () => {
  const { toggleModal } = useContentEditorPreferencesContext();

  return (
    <Button
      data-test={'template-editor-preferences-button'}
      onClick={() => toggleModal()}
      size={BUTTON_SIZES.MEDIUM}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <Settings />
      <span>{displayContent.btnPreferences}</span>
    </Button>
  );
};

export default PreferencesButton;
